import React from 'react';
import { colorPalette } from '@lib/constants';

const AvatarBadge = ({ name, index, size = 'sm' }) => {
  const customSize = {
    sm: 'w-[38px] h-[38px]',
    md: 'w-[48px] h-[48px]',
    lg: 'w-[58px] h-[58px]',
  };
  return (
    <div
      key={index}
      className={`${customSize[size]} rounded-full flex justify-center items-center relative`}
      style={{
        backgroundColor: colorPalette[index % colorPalette.length],
        marginRight: '-12px',
        zIndex: index,
      }}
    >
      <div className="text-[#212121] avatar-text font-semibold font-['Inter'] leading-tight">
        {name}
      </div>
    </div>
  );
};

export default AvatarBadge;
